export enum BetStatus {
    INVALID,
    ACTIVE,
    WON,
    LOST,
    RETURNED,
    PUSH,
    TIE,
}
